<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import type { SbImage, SbLink } from '../types';
	import Image from '../components/image.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import PageGrid16 from '../components/pageGrid16.svelte';

	interface Props {
		content: ISbStoryData<{
			icon: SbImage;
			eyebrow: string;
			text: string;
			cta_label: string;
			cta_link: SbLink;
			value_props: Array<ISbStoryData['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="mb-12 mt-12 lg:mb-8 lg:mt-16 lg:pb-8 lg:pt-16">
	<PageGrid16 margin>
		<div class="col-span-full lg:col-start-2 lg:col-end-[16]">
			<div
				class="flex items-center rounded-2xl bg-brown-6 px-5 py-8 max-lg:flex-col lg:justify-between lg:px-12"
			>
				<div class="flex items-center max-lg:mb-6 max-lg:flex-col lg:gap-x-8">
					<Image
						class="h-16 w-16 max-lg:mb-4 lg:h-24 lg:w-24"
						width={96}
						height={96}
						src={content.icon.filename}
						alt={content.icon.alt}
						title={content.icon.title}
					/>
					<div class="flex flex-col gap-y-1 max-lg:text-center">
						<span class="text-[14px]/[160%] text-brown-4 lg:text-[16px]/[150%]"
							>{content.eyebrow}</span
						>
						<h1
							class="text-[24px]/[100%] font-semibold tracking-[-.24px] text-brown-1 lg:text-[32px]/[110%] lg:tracking-[-.32px]"
						>
							{content.text}
						</h1>
					</div>
				</div>

				<Button class="lg:hidden" href={getSbUrl(content.cta_link)} target={content.cta_link.target}
					>{content.cta_label}</Button
				>
				<Button
					class="btn-large max-lg:hidden"
					href={getSbUrl(content.cta_link)}
					target={content.cta_link.target}>{content.cta_label}</Button
				>
			</div>
		</div>
	</PageGrid16>

	{#if content.value_props.length > 0}
		<div class="mt-12 lg:mt-16">
			{#each content.value_props as valueProp}
				<Blok content={valueProp} />
			{/each}
		</div>
	{/if}
</section>
